// app/javascript/initMessages.js

const initMessages = (container = document.getElementById("messages")) => {
    if (!container) return

    const currentUserId = container.dataset.currentUserId
    const applyClassOn = (msg) => {
        const userId = msg.dataset.userId
        if (userId === currentUserId) {
            msg.classList.add("sent")
            msg.classList.remove("received")
        } else {
            msg.classList.add("received")
            msg.classList.remove("sent")
        }
    }

    // applique sur tous les messages existants
    container.querySelectorAll(".message").forEach(applyClassOn)

    // observe les ajouts et traite chaque nouvelle bulle
    new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (!(node instanceof HTMLElement)) return
                if (node.matches(".message")) applyClassOn(node)
                node.querySelectorAll?.(".message").forEach(applyClassOn)
            })
        })
    }).observe(container, { childList: true })
}

export { initMessages }
